import {
  getPieceColor,
  getPieceTextColor,
  OdontogramTeethArchProps,
  showToothBorder
} from './odontogramTeethArchUtils';

export default function OdontogramUpperTeethArch(props: OdontogramTeethArchProps) {
  return (
    <svg width={327} height={270} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_741_3561)" onClick={() => props.onPieceClick('12')}>
        <path
          {...showToothBorder('12', props)}
          id="12"
          d="M122.98 36.4488C119.522 37.5542 113.896 39.4492 110.254 41.1715C106.974 42.7229 103.066 45.5264 100.347 47.6203C98.4952 49.0466 98.3338 51.7395 99.9484 53.4298C106.971 60.7815 117.572 70.98 124.14 67.9536C130.93 64.8246 129.35 48.3129 126.904 38.5718C126.471 36.8477 124.674 35.9076 122.98 36.4488Z"
          fill={`${getPieceColor('12', props)}`}
        />
      </g>
      <g filter="url(#filter1_d_741_3561)" onClick={() => props.onPieceClick('11')}>
        <path
          {...showToothBorder('11', props)}
          id="11"
          d="M159.269 28.5491C155.522 28.4491 148.705 28.4208 143.888 29.2878C139.629 30.0543 134.019 32.045 130.731 33.2955C129.226 33.8678 128.534 35.5856 129.144 37.0756C133.08 46.6952 139.086 63.1031 151.196 61.3734C159.947 60.1236 161.647 42.2507 161.949 31.3813C161.991 29.8518 160.799 28.5899 159.269 28.5491Z"
          fill={`${getPieceColor('11', props)}`}
        />
      </g>
      <g filter="url(#filter2_d_741_3561)" onClick={() => props.onPieceClick('13')}>
        <path
          {...showToothBorder('13', props)}
          id="13"
          d="M101.953 60.909C106.611 73.6223 107.543 84.1108 103.195 86.0178C98.8479 87.9248 80.8383 84.3377 77.4227 72.351C75.6838 66.2486 79.6998 60.3792 82.3909 58.3663C86.5311 54.9761 97.2956 48.1956 101.953 60.909Z"
          fill={`${getPieceColor('13', props)}`}
        />
      </g>
      <g filter="url(#filter3_d_741_3561)" onClick={() => props.onPieceClick('14')}>
        <path
          {...showToothBorder('14', props)}
          id="14"
          d="M86.0373 88.4029C90.8098 95.6129 91.4457 104.39 86.9913 108.465C82.5368 112.541 72.674 110.033 65.9923 105.017C58.0476 99.0535 58.585 88.8185 64.1977 84.1117C69.8104 79.4049 81.2647 81.193 86.0373 88.4029Z"
          fill={`${getPieceColor('14', props)}`}
        />
        <g filter="url(#filter4_f_741_3561)" onClick={() => props.onPieceClick('14')}>
          <path
            d="M74.4991 99.4523C74.9927 96.8027 78.7916 93.6562 81.2813 92.3106C82.7408 91.5654 81.8823 90.2406 79.5643 91.0893C78.1478 91.6482 77.9117 90.0543 77.0532 88.7915C75.6366 86.7215 74.9069 87.1976 75.98 89.8058C76.3375 90.6682 76.5095 91.5916 76.4856 92.52C76.4616 93.4484 76.2423 94.3624 75.8408 95.2066C75.4393 96.0507 74.8641 96.8073 74.1501 97.4304C73.4362 98.0535 72.5983 98.5301 71.6874 98.8313C68.425 99.8249 68.5967 101.026 69.7772 101.191C70.9577 101.357 72.3742 99.887 74.0698 102.682C74.9927 104.193 76.0659 103.385 75.2932 102.081C74.7995 101.129 74.2844 100.612 74.4991 99.4523Z"
            fill={`${getPieceColor('14', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter5_d_741_3561)" onClick={() => props.onPieceClick('15')}>
        <path
          {...showToothBorder('15', props)}
          id="15"
          d="M72.9249 113.759C79.2182 120.459 82.95 127.869 79.4726 133.176C75.9952 138.483 61.9258 138.646 54.668 134.412C46.0382 129.378 41.4622 121.455 47.1029 112.181C52.7435 102.907 66.6315 107.059 72.9249 113.759Z"
          fill={`${getPieceColor('15', props)}`}
        />
        <g filter="url(#filter6_f_741_3561)">
          <path
            d="M65.5032 116.787C64.0669 117.289 63.0746 117.395 62.1345 118.743C61.3019 120.358 60.7988 122.127 60.6553 123.943C60.5117 125.76 60.7306 127.587 61.2989 129.316C61.7689 130.717 60.0193 131.14 58.9748 129.104C58.3481 127.836 56.9118 128.84 55.2928 129.104C52.6814 129.712 50.5662 128.153 53.2298 126.99C59.6537 124.135 60.7505 120.012 59.0792 116.919C56.9901 113.112 58.2958 111.897 59.5754 112.769C60.855 113.641 60.6983 116.39 65.0593 114.883C67.5401 114.143 67.5923 115.941 65.5032 116.787Z"
            fill={`${getPieceColor('15', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter7_d_741_3561)" onClick={() => props.onPieceClick('16')}>
        <path
          {...showToothBorder('16', props)}
          id="16"
          d="M43.4424 137.867C55.2441 132.149 80.7967 152.324 71.1347 173.007C65.0625 186.006 42.4326 183.814 34.4744 175.267C28.0432 168.361 30.0317 157.95 34.4986 154.354C38.9655 150.758 31.6407 143.584 43.4424 137.867Z"
          fill={`${getPieceColor('16', props)}`}
        />
        <g filter="url(#filter8_f_741_3561)">
          <path
            d="M39.0811 157.575C38.3468 159.745 42.7872 160.13 44.8501 161.075C49.1857 163.245 50.6192 167.9 49.4304 173.5C51.0388 171.365 51.8779 166.885 53.2415 166.045C56.9477 163.77 69.9194 169.545 58.2064 163C51.5982 159.185 56.668 154.915 53.5911 152.5C47.7172 161.915 39.6055 156.35 39.0811 157.575Z"
            fill={`${getPieceColor('16', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter9_d_741_3561)" onClick={() => props.onPieceClick('18')}>
        <path
          {...showToothBorder('18', props)}
          id="18"
          d="M36.3614 228.48C49.691 229.625 57.4042 240.639 58.3649 254.684C59.3255 268.729 32.022 268.692 26.0558 266.13C20.0895 263.568 19.884 259.24 18.1936 253.99C16.6365 249.154 13.7918 247.92 15.0346 238.665C16.2774 229.41 26.9596 227.673 36.3614 228.48Z"
          fill={`${getPieceColor('18', props)}`}
        />
        <g filter="url(#filter10_f_741_3561)">
          <path
            d="M25.8424 238.093C34.692 241.682 34.095 246.241 31.3207 248.287C29.3892 249.687 27.809 247.892 25.6668 247.964C24.2621 247.964 23.4193 249.364 24.4728 250.226C25.8041 250.89 27.191 251.43 28.6167 251.841C30.1267 253.636 27.6334 255.754 26.5096 257.944C25.0698 260.816 27.0013 262.682 28.9678 260.636C32.4796 257.046 31.5314 253.241 35.9913 257.369C42.6987 263.831 47.4746 259.631 40.697 255.862C36.2371 253.385 33.6736 240.318 41.3994 240.569C43.7522 240.569 44.5599 238.667 43.6117 237.303C41.6452 234.467 37.7472 238.739 34.7973 238.452C32.5147 238.236 31.0398 235.795 29.1083 234.862C26.0531 233.39 22.3307 236.8 25.8424 238.093Z"
            fill={`${getPieceColor('18', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter11_d_741_3561)" onClick={() => props.onPieceClick('17')}>
        <path
          {...showToothBorder('17', props)}
          id="17"
          d="M21.5343 202.223C20.0958 194.596 19.0169 188.876 25.9738 185.056C32.9313 181.236 52.8406 186.942 57.8927 194.249C62.9448 201.556 61.9921 206.961 60.7227 213.002C59.4532 219.042 55.0234 224.45 49.3329 225.726C43.6423 227.002 35.1088 225.102 26.893 221.93C18.6772 218.757 22.9734 209.853 21.5347 202.225L21.5343 202.223Z"
          fill={`${getPieceColor('17', props)}`}
        />
        <g filter="url(#filter12_f_741_3561)">
          <path
            d="M36.2117 201.881C40.057 203.112 39.0601 207.885 33.5628 209.746C29.5751 211.037 31.455 215.99 33.3064 213.498C39.0031 205.904 39.0031 216.5 42.7915 216.5C44.3296 216.5 45.1271 215.539 41.7091 211.787C40.9726 211.099 40.4596 210.185 40.2425 209.173C40.0253 208.162 40.115 207.104 40.4989 206.149C40.8828 205.194 41.5415 204.39 42.3821 203.85C43.2227 203.311 44.2028 203.063 45.1841 203.142C47.6337 202.902 47.5767 200.14 45.1841 199.87C43.4751 199.66 41.4528 200.17 41.3103 198.189C41.0255 193.866 40.3134 193.146 38.462 197.078C37.0663 199.66 23.9068 197.949 36.2117 201.881Z"
            fill={`${getPieceColor('17', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter13_d_741_3561)" onClick={() => props.onPieceClick('22')}>
        <path
          {...showToothBorder('22', props)}
          id="22"
          d="M205.02 36.4488C208.478 37.5542 214.104 39.4492 217.746 41.1715C221.026 42.7229 224.934 45.5264 227.653 47.6203C229.505 49.0466 229.666 51.7395 228.052 53.4298C221.029 60.7815 210.428 70.98 203.86 67.9536C197.07 64.8246 198.65 48.3129 201.096 38.5718C201.529 36.8477 203.326 35.9076 205.02 36.4488Z"
          fill={`${getPieceColor('22', props)}`}
        />
      </g>
      <g filter="url(#filter14_d_741_3561)" onClick={() => props.onPieceClick('21')}>
        <path
          {...showToothBorder('21', props)}
          id="21"
          d="M168.731 28.5491C172.478 28.4491 179.295 28.4208 184.112 29.2878C188.371 30.0543 193.981 32.045 197.269 33.2955C198.774 33.8678 199.466 35.5856 198.856 37.0756C194.92 46.6952 188.914 63.1031 176.804 61.3734C168.053 60.1236 166.353 42.2507 166.051 31.3813C166.009 29.8518 167.201 28.5899 168.731 28.5491Z"
          fill={`${getPieceColor('21', props)}`}
        />
      </g>
      <g filter="url(#filter15_d_741_3561)" onClick={() => props.onPieceClick('23')}>
        <path
          {...showToothBorder('23', props)}
          id="23"
          d="M226.047 60.909C221.389 73.6223 220.457 84.1108 224.805 86.0178C229.152 87.9248 247.162 84.3377 250.577 72.351C252.316 66.2486 248.3 60.3792 245.609 58.3663C241.469 54.9761 230.704 48.1956 226.047 60.909Z"
          fill={`${getPieceColor('23', props)}`}
        />
      </g>
      <g filter="url(#filter16_d_741_3561)" onClick={() => props.onPieceClick('24')}>
        <path
          {...showToothBorder('24', props)}
          id="24"
          d="M241.963 88.4029C237.19 95.6129 236.554 104.39 241.009 108.465C245.463 112.541 255.326 110.033 262.008 105.017C269.952 99.0535 269.415 88.8185 263.802 84.1117C258.19 79.4049 246.735 81.193 241.963 88.4029Z"
          fill={`${getPieceColor('24', props)}`}
        />
        <g filter="url(#filter17_f_741_3561)">
          <path
            d="M253.501 99.4523C253.007 96.8027 249.208 93.6562 246.719 92.3106C245.259 91.5654 246.118 90.2406 248.436 91.0893C249.852 91.6482 250.088 90.0543 250.947 88.7915C252.363 86.7215 253.093 87.1976 252.02 89.8058C251.662 90.6682 251.49 91.5916 251.514 92.52C251.538 93.4484 251.758 94.3624 252.159 95.2066C252.561 96.0507 253.136 96.8073 253.85 97.4304C254.564 98.0535 255.402 98.5301 256.313 98.8313C259.575 99.8249 259.403 101.026 258.223 101.191C257.042 101.357 255.626 99.887 253.93 102.682C253.007 104.193 251.934 103.385 252.707 102.081C253.2 101.129 253.716 100.612 253.501 99.4523Z"
            fill={`${getPieceColor('24', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter18_d_741_3561)" onClick={() => props.onPieceClick('25')}>
        <path
          {...showToothBorder('25', props)}
          id="25"
          d="M255.075 113.759C248.782 120.459 245.05 127.869 248.527 133.176C252.005 138.483 266.074 138.646 273.332 134.412C281.962 129.378 286.538 121.455 280.897 112.181C275.257 102.907 261.369 107.059 255.075 113.759Z"
          fill={`${getPieceColor('25', props)}`}
        />
        <g filter="url(#filter19_f_741_3561)">
          <path
            d="M262.497 116.787C263.933 117.289 264.925 117.395 265.865 118.743C266.698 120.358 267.201 122.127 267.345 123.943C267.488 125.76 267.269 127.587 266.701 129.316C266.231 130.717 267.981 131.14 269.025 129.104C269.652 127.836 271.088 128.84 272.707 129.104C275.319 129.712 277.434 128.153 274.77 126.99C268.346 124.135 267.25 120.012 268.921 116.919C271.01 113.112 269.704 111.897 268.425 112.769C267.145 113.641 267.302 116.39 262.941 114.883C260.46 114.143 260.408 115.941 262.497 116.787Z"
            fill={`${getPieceColor('25', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter20_d_741_3561)" onClick={() => props.onPieceClick('26')}>
        <path
          {...showToothBorder('26', props)}
          id="26"
          d="M284.558 137.867C272.756 132.149 247.203 152.324 256.865 173.007C262.938 186.006 285.567 183.814 293.526 175.267C299.957 168.361 297.968 157.95 293.501 154.354C289.035 150.758 296.359 143.584 284.558 137.867Z"
          fill={`${getPieceColor('26', props)}`}
        />
        <g filter="url(#filter21_f_741_3561)">
          <path
            d="M288.919 157.575C289.653 159.745 285.213 160.13 283.15 161.075C278.814 163.245 277.381 167.9 278.57 173.5C276.961 171.365 276.122 166.885 274.758 166.045C271.052 163.77 258.081 169.545 269.794 163C276.402 159.185 271.332 154.915 274.409 152.5C280.283 161.915 288.394 156.35 288.919 157.575Z"
            fill={`${getPieceColor('26', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter22_d_741_3561)" onClick={() => props.onPieceClick('28')}>
        <path
          {...showToothBorder('28', props)}
          id="28"
          d="M291.639 228.48C278.309 229.625 270.596 240.639 269.635 254.684C268.675 268.729 295.978 268.692 301.944 266.13C307.91 263.568 308.116 259.24 309.806 253.99C311.363 249.154 314.208 247.92 312.965 238.665C311.723 229.41 301.04 227.673 291.639 228.48Z"
          fill={`${getPieceColor('28', props)}`}
        />
        <g filter="url(#filter23_f_741_3561)">
          <path
            d="M302.158 238.093C293.308 241.682 293.905 246.241 296.679 248.287C298.611 249.687 300.191 247.892 302.333 247.964C303.738 247.964 304.581 249.364 303.527 250.226C302.196 250.89 300.809 251.43 299.383 251.841C297.873 253.636 300.367 255.754 301.49 257.944C302.93 260.816 300.999 262.682 299.032 260.636C295.52 257.046 296.469 253.241 292.009 257.369C285.301 263.831 280.525 259.631 287.303 255.862C291.763 253.385 294.326 240.318 286.601 240.569C284.248 240.569 283.44 238.667 284.388 237.303C286.355 234.467 290.253 238.739 293.203 238.452C295.485 238.236 296.96 235.795 298.892 234.862C301.947 233.39 305.669 236.8 302.158 238.093Z"
            fill={`${getPieceColor('28', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <g filter="url(#filter24_d_741_3561)" onClick={() => props.onPieceClick('27')}>
        <path
          {...showToothBorder('27', props)}
          id="27"
          d="M306.466 202.223C307.904 194.596 308.983 188.876 302.026 185.056C295.069 181.236 275.159 186.942 270.107 194.249C265.055 201.556 266.008 206.961 267.277 213.002C268.547 219.042 272.977 224.45 278.667 225.726C284.358 227.002 292.891 225.102 301.107 221.93C309.323 218.757 305.027 209.853 306.465 202.225L306.466 202.223Z"
          fill={`${getPieceColor('27', props)}`}
        />
        <g filter="url(#filter25_f_741_3561)">
          <path
            d="M291.788 201.881C287.943 203.112 288.94 207.885 294.437 209.746C298.425 211.037 296.545 215.99 294.694 213.498C288.997 205.904 288.997 216.5 285.209 216.5C283.67 216.5 282.873 215.539 286.291 211.787C287.027 211.099 287.54 210.185 287.758 209.173C287.975 208.162 287.885 207.104 287.501 206.149C287.117 205.194 286.458 204.39 285.618 203.85C284.777 203.311 283.797 203.063 282.816 203.142C280.366 202.902 280.423 200.14 282.816 199.87C284.525 199.66 286.547 200.17 286.69 198.189C286.975 193.866 287.687 193.146 289.538 197.078C290.934 199.66 304.093 197.949 291.788 201.881Z"
            fill={`${getPieceColor('27', props, true)}`}
            fillOpacity="0.2"
          />
        </g>
      </g>
      <path
        d="M28.7403 246.44V245.335H31.3663V254.5H30.1183V246.44H28.7403ZM33.2267 247.493C33.2267 247.042 33.348 246.631 33.5907 246.258C33.8334 245.885 34.193 245.591 34.6697 245.374C35.1464 245.157 35.714 245.049 36.3727 245.049C37.0314 245.049 37.5947 245.157 38.0627 245.374C38.5394 245.591 38.899 245.885 39.1417 246.258C39.3844 246.631 39.5057 247.042 39.5057 247.493C39.5057 248.004 39.367 248.446 39.0897 248.819C38.8124 249.192 38.392 249.456 37.8287 249.612C38.4354 249.777 38.9077 250.063 39.2457 250.47C39.5837 250.877 39.7527 251.38 39.7527 251.978C39.7527 252.845 39.445 253.525 38.8297 254.019C38.2144 254.513 37.3954 254.76 36.3727 254.76C35.35 254.76 34.531 254.513 33.9157 254.019C33.3004 253.525 32.9927 252.845 32.9927 251.978C32.9927 251.38 33.1574 250.877 33.4867 250.47C33.8247 250.063 34.297 249.777 34.9037 249.612C34.3404 249.456 33.92 249.192 33.6427 248.819C33.3654 248.446 33.2267 248.004 33.2267 247.493ZM34.3967 247.662C34.3967 248.182 34.5744 248.585 34.9297 248.871C35.285 249.148 35.766 249.287 36.3727 249.287C36.9794 249.287 37.456 249.148 37.8027 248.871C38.158 248.585 38.3357 248.182 38.3357 247.662C38.3357 247.142 38.158 246.743 37.8027 246.466C37.4474 246.18 36.9707 246.037 36.3727 246.037C35.7747 246.037 35.2937 246.18 34.9297 246.466C34.5744 246.743 34.3967 247.142 34.3967 247.662ZM34.1497 251.913C34.1497 252.502 34.349 252.962 34.7477 253.291C35.1464 253.612 35.688 253.772 36.3727 253.772C37.0487 253.772 37.586 253.607 37.9847 253.278C38.3834 252.949 38.5827 252.494 38.5827 251.913C38.5827 251.324 38.3747 250.877 37.9587 250.574C37.5427 250.271 37.014 250.119 36.3727 250.119C35.7227 250.119 35.1897 250.271 34.7737 250.574C34.3577 250.877 34.1497 251.324 34.1497 251.913Z"
        fill={getPieceTextColor('18', props)}
        onClick={() => props.onPieceClick('18')}
      />
      <path
        d="M282.296 253.59C283.769 252.602 284.948 251.623 285.832 250.652C286.716 249.673 287.158 248.763 287.158 247.922C287.158 247.402 287.023 246.986 286.755 246.674C286.495 246.353 286.07 246.193 285.481 246.193C284.874 246.193 284.415 246.388 284.103 246.778C283.791 247.159 283.617 247.688 283.583 248.364H282.413C282.473 247.341 282.79 246.557 283.362 246.011C283.934 245.456 284.67 245.179 285.572 245.179C286.43 245.179 287.11 245.409 287.613 245.868C288.115 246.327 288.367 246.977 288.367 247.818C288.367 248.511 288.141 249.218 287.691 249.937C287.249 250.648 286.69 251.311 286.014 251.926C285.346 252.533 284.657 253.048 283.947 253.473H288.601V254.448H282.296V253.59ZM290.048 247.493C290.048 247.042 290.17 246.631 290.412 246.258C290.655 245.885 291.015 245.591 291.491 245.374C291.968 245.157 292.536 245.049 293.194 245.049C293.853 245.049 294.416 245.157 294.884 245.374C295.361 245.591 295.721 245.885 295.963 246.258C296.206 246.631 296.327 247.042 296.327 247.493C296.327 248.004 296.189 248.446 295.911 248.819C295.634 249.192 295.214 249.456 294.65 249.612C295.257 249.777 295.729 250.063 296.067 250.47C296.405 250.877 296.574 251.38 296.574 251.978C296.574 252.845 296.267 253.525 295.651 254.019C295.036 254.513 294.217 254.76 293.194 254.76C292.172 254.76 291.353 254.513 290.737 254.019C290.122 253.525 289.814 252.845 289.814 251.978C289.814 251.38 289.979 250.877 290.308 250.47C290.646 250.063 291.119 249.777 291.725 249.612C291.162 249.456 290.742 249.192 290.464 248.819C290.187 248.446 290.048 248.004 290.048 247.493ZM291.218 247.662C291.218 248.182 291.396 248.585 291.751 248.871C292.107 249.148 292.588 249.287 293.194 249.287C293.801 249.287 294.278 249.148 294.624 248.871C294.98 248.585 295.157 248.182 295.157 247.662C295.157 247.142 294.98 246.743 294.624 246.466C294.269 246.18 293.792 246.037 293.194 246.037C292.596 246.037 292.115 246.18 291.751 246.466C291.396 246.743 291.218 247.142 291.218 247.662ZM290.971 251.913C290.971 252.502 291.171 252.962 291.569 253.291C291.968 253.612 292.51 253.772 293.194 253.772C293.87 253.772 294.408 253.607 294.806 253.278C295.205 252.949 295.404 252.494 295.404 251.913C295.404 251.324 295.196 250.877 294.78 250.574C294.364 250.271 293.836 250.119 293.194 250.119C292.544 250.119 292.011 250.271 291.595 250.574C291.179 250.877 290.971 251.324 290.971 251.913Z"
        fill={getPieceTextColor('28', props)}
        onClick={() => props.onPieceClick('28')}
      />
      <path
        d="M33.5147 203.44V202.335H36.1407V211.5H34.8927V203.44H33.5147ZM43.2661 203.193L39.7951 211.5H38.5471L42.0701 203.31H37.2601V202.283H43.2661V203.193Z"
        fill={getPieceTextColor('17', props)}
        onClick={() => props.onPieceClick('17')}
      />
      <path
        d="M278.07 210.59C279.543 209.602 280.722 208.623 281.606 207.652C282.49 206.673 282.932 205.763 282.932 204.922C282.932 204.402 282.798 203.986 282.529 203.674C282.269 203.353 281.844 203.193 281.255 203.193C280.648 203.193 280.189 203.388 279.877 203.778C279.565 204.159 279.392 204.688 279.357 205.364H278.187C278.248 204.341 278.564 203.557 279.136 203.011C279.708 202.456 280.445 202.179 281.346 202.179C282.204 202.179 282.884 202.409 283.387 202.868C283.89 203.327 284.141 203.977 284.141 204.818C284.141 205.511 283.916 206.218 283.465 206.937C283.023 207.648 282.464 208.311 281.788 208.926C281.121 209.533 280.432 210.048 279.721 210.473H284.375V211.448H278.07V210.59ZM291.088 203.193L287.617 211.5H286.369L289.892 203.31H285.082V202.283H291.088V203.193Z"
        fill={getPieceTextColor('27', props)}
        onClick={() => props.onPieceClick('27')}
      />
      <path
        d="M43.7657 162.44V161.335H46.3917V170.5H45.1437V162.44H43.7657ZM53.2441 163.779C53.1748 163.233 52.9884 162.813 52.6851 162.518C52.3904 162.215 51.9788 162.063 51.4501 162.063C50.7134 162.063 50.1544 162.349 49.7731 162.921C49.4004 163.493 49.2141 164.399 49.2141 165.638L49.2271 166.119C49.3571 165.599 49.6561 165.187 50.1241 164.884C50.5921 164.572 51.1424 164.416 51.7751 164.416C52.6851 164.416 53.3958 164.689 53.9071 165.235C54.4271 165.781 54.6871 166.544 54.6871 167.523C54.6871 168.095 54.5744 168.615 54.3491 169.083C54.1238 169.542 53.7771 169.911 53.3091 170.188C52.8498 170.457 52.2778 170.591 51.5931 170.591C50.2844 170.591 49.3831 170.179 48.8891 169.356C48.4038 168.533 48.1611 167.415 48.1611 166.002C48.1611 164.373 48.4211 163.151 48.9411 162.336C49.4698 161.513 50.3278 161.101 51.5151 161.101C52.3904 161.101 53.0621 161.348 53.5301 161.842C54.0068 162.336 54.2884 162.982 54.3751 163.779H53.2441ZM49.3571 167.328C49.3571 167.961 49.5391 168.494 49.9031 168.927C50.2758 169.352 50.8304 169.564 51.5671 169.564C52.1738 169.564 52.6591 169.386 53.0231 169.031C53.3871 168.667 53.5691 168.16 53.5691 167.51C53.5691 166.808 53.3871 166.275 53.0231 165.911C52.6591 165.538 52.1564 165.352 51.5151 165.352C51.1511 165.352 50.8044 165.426 50.4751 165.573C50.1458 165.72 49.8771 165.946 49.6691 166.249C49.4611 166.544 49.3571 166.903 49.3571 167.328Z"
        fill={getPieceTextColor('16', props)}
        onClick={() => props.onPieceClick('16')}
      />
      <path
        d="M268.321 169.59C269.794 168.602 270.973 167.623 271.857 166.652C272.741 165.673 273.183 164.763 273.183 163.922C273.183 163.402 273.049 162.986 272.78 162.674C272.52 162.353 272.095 162.193 271.506 162.193C270.899 162.193 270.44 162.388 270.128 162.778C269.816 163.159 269.643 163.688 269.608 164.364H268.438C268.499 163.341 268.815 162.557 269.387 162.011C269.959 161.456 270.696 161.179 271.597 161.179C272.455 161.179 273.135 161.409 273.638 161.868C274.141 162.327 274.392 162.977 274.392 163.818C274.392 164.511 274.167 165.218 273.716 165.937C273.274 166.648 272.715 167.311 272.039 167.926C271.372 168.533 270.683 169.048 269.972 169.473H274.626V170.448H268.321V169.59ZM281.066 163.779C280.997 163.233 280.81 162.813 280.507 162.518C280.212 162.215 279.801 162.063 279.272 162.063C278.535 162.063 277.976 162.349 277.595 162.921C277.222 163.493 277.036 164.399 277.036 165.638L277.049 166.119C277.179 165.599 277.478 165.187 277.946 164.884C278.414 164.572 278.964 164.416 279.597 164.416C280.507 164.416 281.218 164.689 281.729 165.235C282.249 165.781 282.509 166.544 282.509 167.523C282.509 168.095 282.396 168.615 282.171 169.083C281.946 169.542 281.599 169.911 281.131 170.188C280.672 170.457 280.1 170.591 279.415 170.591C278.106 170.591 277.205 170.179 276.711 169.356C276.226 168.533 275.983 167.415 275.983 166.002C275.983 164.373 276.243 163.151 276.763 162.336C277.292 161.513 278.15 161.101 279.337 161.101C280.212 161.101 280.884 161.348 281.352 161.842C281.829 162.336 282.11 162.982 282.197 163.779H281.066ZM277.179 167.328C277.179 167.961 277.361 168.494 277.725 168.927C278.098 169.352 278.652 169.564 279.389 169.564C279.996 169.564 280.481 169.386 280.845 169.031C281.209 168.667 281.391 168.16 281.391 167.51C281.391 166.808 281.209 166.275 280.845 165.911C280.481 165.538 279.978 165.352 279.337 165.352C278.973 165.352 278.626 165.426 278.297 165.573C277.968 165.72 277.699 165.946 277.491 166.249C277.283 166.544 277.179 166.903 277.179 167.328Z"
        fill={getPieceTextColor('26', props)}
        onClick={() => props.onPieceClick('26')}
      />
      <path
        d="M55.7974 120.44V119.335H58.4234V128.5H57.1754V120.44H55.7974ZM66.2768 120.271H61.5708V123.339C61.7875 123.044 62.0995 122.81 62.5068 122.637C62.9142 122.464 63.3605 122.377 63.8458 122.377C64.4958 122.377 65.0332 122.516 65.4578 122.793C65.8912 123.062 66.2075 123.421 66.4068 123.872C66.6148 124.314 66.7188 124.808 66.7188 125.354C66.7188 126.299 66.4545 127.07 65.9258 127.668C65.3972 128.266 64.6215 128.565 63.5988 128.565C62.6802 128.565 61.9305 128.318 61.3498 127.824C60.7692 127.321 60.4442 126.65 60.3748 125.809H61.5448C61.6402 126.346 61.8612 126.767 62.2078 127.07C62.5632 127.365 63.0095 127.512 63.5468 127.512C64.2142 127.512 64.7168 127.313 65.0548 126.914C65.3928 126.515 65.5618 125.991 65.5618 125.341C65.5618 124.708 65.3885 124.214 65.0418 123.859C64.6952 123.504 64.2055 123.326 63.5728 123.326C63.1222 123.326 62.7278 123.426 62.3898 123.625C62.0518 123.816 61.7962 124.076 61.6228 124.405H60.4788V119.218H66.2768V120.271Z"
        fill={getPieceTextColor('15', props)}
        onClick={() => props.onPieceClick('15')}
      />
      <path
        d="M258.353 127.59C259.826 126.602 261.005 125.623 261.889 124.652C262.773 123.673 263.215 122.763 263.215 121.922C263.215 121.402 263.08 120.986 262.812 120.674C262.552 120.353 262.127 120.193 261.538 120.193C260.931 120.193 260.472 120.388 260.16 120.778C259.848 121.159 259.674 121.688 259.64 122.364H258.47C258.53 121.341 258.847 120.557 259.419 120.011C259.991 119.456 260.727 119.179 261.629 119.179C262.487 119.179 263.167 119.409 263.67 119.868C264.172 120.327 264.424 120.977 264.424 121.818C264.424 122.511 264.198 123.218 263.748 123.937C263.306 124.648 262.747 125.311 262.071 125.926C261.403 126.533 260.714 127.048 260.004 127.473H264.658V128.448H258.353V127.59ZM272.099 120.271H267.393V123.339C267.609 123.044 267.921 122.81 268.329 122.637C268.736 122.464 269.182 122.377 269.668 122.377C270.318 122.377 270.855 122.516 271.28 122.793C271.713 123.062 272.029 123.421 272.229 123.872C272.437 124.314 272.541 124.808 272.541 125.354C272.541 126.299 272.276 127.07 271.748 127.668C271.219 128.266 270.443 128.565 269.421 128.565C268.502 128.565 267.752 128.318 267.172 127.824C266.591 127.321 266.266 126.65 266.197 125.809H267.367C267.462 126.346 267.683 126.767 268.03 127.07C268.385 127.365 268.831 127.512 269.369 127.512C270.036 127.512 270.539 127.313 270.877 126.914C271.215 126.515 271.384 125.991 271.384 125.341C271.384 124.708 271.21 124.214 270.864 123.859C270.517 123.504 270.027 123.326 269.395 123.326C268.944 123.326 268.55 123.426 268.212 123.625C267.874 123.816 267.618 124.076 267.445 124.405H266.301V119.218H272.099V120.271Z"
        fill={getPieceTextColor('25', props)}
        onClick={() => props.onPieceClick('25')}
      />
      <path
        d="M67.772 92.44V91.335H70.398V100.5H69.15V92.44H67.772ZM71.7384 98.394V97.406L76.4444 91.27H77.7184V97.367H79.0704V98.394H77.7184V100.5H76.5224V98.394H71.7384ZM76.6004 92.713L72.9864 97.367H76.6004V92.713Z"
        fill={getPieceTextColor('14', props)}
        onClick={() => props.onPieceClick('14')}
      />
      <path
        d="M245.327 99.59C246.801 98.602 247.979 97.6227 248.863 96.652C249.747 95.6727 250.189 94.7627 250.189 93.922C250.189 93.402 250.055 92.986 249.786 92.674C249.526 92.3533 249.102 92.193 248.512 92.193C247.906 92.193 247.446 92.388 247.134 92.778C246.822 93.1593 246.649 93.688 246.614 94.364H245.444C245.505 93.3413 245.821 92.557 246.393 92.011C246.965 91.4563 247.702 91.179 248.603 91.179C249.461 91.179 250.142 91.4087 250.644 91.868C251.147 92.3273 251.398 92.9773 251.398 93.818C251.398 94.5113 251.173 95.2177 250.722 95.937C250.28 96.6477 249.721 97.3107 249.045 97.926C248.378 98.5327 247.689 99.0483 246.978 99.473H251.632V100.448H245.327V99.59ZM252.56 98.394V97.406L257.266 91.27H258.54V97.367H259.892V98.394H258.54V100.5H257.344V98.394H252.56ZM257.422 92.713L253.808 97.367H257.422V92.713Z"
        fill={getPieceTextColor('24', props)}
        onClick={() => props.onPieceClick('24')}
      />
      <path
        d="M85.9752 67.44V66.335H88.6012V75.5H87.3532V67.44H85.9752ZM93.4256 66.088C94.0149 66.088 94.5219 66.192 94.9466 66.4C95.3712 66.608 95.6919 66.894 95.9086 67.258C96.1252 67.622 96.2336 68.0337 96.2336 68.493C96.2336 69.065 96.0646 69.546 95.7266 69.936C95.3972 70.326 94.9119 70.56 94.2706 70.638V70.716C94.9379 70.8893 95.4579 71.158 95.8306 71.522C96.2119 71.886 96.4026 72.3887 96.4026 73.03C96.4026 73.784 96.1512 74.3993 95.6486 74.876C95.1459 75.3527 94.4222 75.591 93.4776 75.591C92.5329 75.591 91.7659 75.3483 91.1766 74.863C90.5959 74.369 90.2536 73.6497 90.1496 72.705H91.3196C91.3976 73.277 91.6142 73.732 91.9696 74.07C92.3336 74.408 92.8232 74.577 93.4386 74.577C94.0192 74.577 94.4656 74.4297 94.7776 74.135C95.0896 73.8317 95.2456 73.4417 95.2456 72.965C95.2456 72.393 95.0202 71.9597 94.5696 71.665C94.1276 71.3617 93.4949 71.21 92.6716 71.21H92.3596V70.222H92.6716C94.2662 70.222 95.0636 69.689 95.0636 68.623C95.0636 68.155 94.9162 67.7823 94.6216 67.505C94.3269 67.2277 93.9196 67.089 93.3996 67.089C92.8796 67.089 92.4419 67.2407 92.0866 67.544C91.7312 67.8387 91.5232 68.2763 91.4626 68.857H90.3056C90.3662 67.9903 90.6652 67.3143 91.2026 66.829C91.7486 66.335 92.4896 66.088 93.4256 66.088Z"
        fill={getPieceTextColor('13', props)}
        onClick={() => props.onPieceClick('13')}
      />
      <path
        d="M228.53 74.59C230.004 73.602 231.182 72.6227 232.066 71.652C232.95 70.6727 233.392 69.7627 233.392 68.922C233.392 68.402 233.258 67.986 232.989 67.674C232.729 67.3533 232.305 67.193 231.715 67.193C231.109 67.193 230.649 67.388 230.337 67.778C230.025 68.1593 229.852 68.688 229.817 69.364H228.647C228.708 68.3413 229.024 67.557 229.596 67.011C230.168 66.4563 230.905 66.179 231.806 66.179C232.664 66.179 233.345 66.4087 233.847 66.868C234.35 67.3273 234.601 67.9773 234.601 68.818C234.601 69.5113 234.376 70.2177 233.925 70.937C233.483 71.6477 232.924 72.3107 232.248 72.926C231.581 73.5327 230.892 74.0483 230.181 74.473H234.835V75.448H228.53V74.59ZM239.247 66.088C239.837 66.088 240.344 66.192 240.768 66.4C241.193 66.608 241.514 66.894 241.73 67.258C241.947 67.622 242.055 68.0337 242.055 68.493C242.055 69.065 241.886 69.546 241.548 69.936C241.219 70.326 240.734 70.56 240.092 70.638V70.716C240.76 70.8893 241.28 71.158 241.652 71.522C242.034 71.886 242.224 72.3887 242.224 73.03C242.224 73.784 241.973 74.3993 241.47 74.876C240.968 75.3527 240.244 75.591 239.299 75.591C238.355 75.591 237.588 75.3483 236.998 74.863C236.418 74.369 236.075 73.6497 235.971 72.705H237.141C237.219 73.277 237.436 73.732 237.791 74.07C238.155 74.408 238.645 74.577 239.26 74.577C239.841 74.577 240.287 74.4297 240.599 74.135C240.911 73.8317 241.067 73.4417 241.067 72.965C241.067 72.393 240.842 71.9597 240.391 71.665C239.949 71.3617 239.317 71.21 238.493 71.21H238.181V70.222H238.493C240.088 70.222 240.885 69.689 240.885 68.623C240.885 68.155 240.738 67.7823 240.443 67.505C240.149 67.2277 239.741 67.089 239.221 67.089C238.701 67.089 238.264 67.2407 237.908 67.544C237.553 67.8387 237.345 68.2763 237.284 68.857H236.127C236.188 67.9903 236.487 67.3143 237.024 66.829C237.57 66.335 238.311 66.088 239.247 66.088Z"
        fill={getPieceTextColor('23', props)}
        onClick={() => props.onPieceClick('23')}
      />
      <path
        d="M110.115 51.44V50.335H112.741V59.5H111.493V51.44H110.115ZM114.224 58.59C115.698 57.602 116.876 56.6227 117.76 55.652C118.644 54.6727 119.086 53.7627 119.086 52.922C119.086 52.402 118.952 51.986 118.683 51.674C118.423 51.3533 117.999 51.193 117.409 51.193C116.803 51.193 116.343 51.388 116.031 51.778C115.719 52.1593 115.546 52.688 115.511 53.364H114.341C114.402 52.3413 114.718 51.557 115.29 51.011C115.862 50.4563 116.599 50.179 117.5 50.179C118.358 50.179 119.039 50.4087 119.541 50.868C120.044 51.3273 120.295 51.9773 120.295 52.818C120.295 53.5113 120.07 54.2177 119.619 54.937C119.177 55.6477 118.618 56.3107 117.942 56.926C117.275 57.5327 116.586 58.0483 115.875 58.473H120.529V59.448H114.224V58.59Z"
        fill={getPieceTextColor('12', props)}
        onClick={() => props.onPieceClick('12')}
      />
      <path
        d="M204.67 58.59C206.143 57.602 207.322 56.6227 208.206 55.652C209.09 54.6727 209.532 53.7627 209.532 52.922C209.532 52.402 209.398 51.986 209.129 51.674C208.869 51.3533 208.444 51.193 207.855 51.193C207.248 51.193 206.789 51.388 206.477 51.778C206.165 52.1593 205.992 52.688 205.957 53.364H204.787C204.848 52.3413 205.164 51.557 205.736 51.011C206.308 50.4563 207.045 50.179 207.946 50.179C208.804 50.179 209.484 50.4087 209.987 50.868C210.49 51.3273 210.741 51.9773 210.741 52.818C210.741 53.5113 210.516 54.2177 210.065 54.937C209.623 55.6477 209.064 56.3107 208.388 56.926C207.721 57.5327 207.032 58.0483 206.321 58.473H210.975V59.448H204.67V58.59ZM212.046 58.59C213.519 57.602 214.698 56.6227 215.582 55.652C216.466 54.6727 216.908 53.7627 216.908 52.922C216.908 52.402 216.774 51.986 216.505 51.674C216.245 51.3533 215.82 51.193 215.231 51.193C214.624 51.193 214.165 51.388 213.853 51.778C213.541 52.1593 213.368 52.688 213.333 53.364H212.163C212.224 52.3413 212.54 51.557 213.112 51.011C213.684 50.4563 214.421 50.179 215.322 50.179C216.18 50.179 216.86 50.4087 217.363 50.868C217.866 51.3273 218.117 51.9773 218.117 52.818C218.117 53.5113 217.892 54.2177 217.441 54.937C216.999 55.6477 216.44 56.3107 215.764 56.926C215.097 57.5327 214.408 58.0483 213.697 58.473H218.351V59.448H212.046V58.59Z"
        fill={getPieceTextColor('22', props)}
        onClick={() => props.onPieceClick('22')}
      />
      <path
        d="M142.937 42.44V41.335H145.563V50.5H144.315V42.44H142.937ZM146.669 42.44V41.335H149.295V50.5H148.047V42.44H146.669Z"
        fill={getPieceTextColor('11', props)}
        onClick={() => props.onPieceClick('11')}
      />
      <path
        d="M173.492 49.59C174.965 48.602 176.144 47.6227 177.028 46.652C177.912 45.6727 178.354 44.7627 178.354 43.922C178.354 43.402 178.219 42.986 177.951 42.674C177.691 42.3533 177.266 42.193 176.677 42.193C176.07 42.193 175.611 42.388 175.299 42.778C174.987 43.1593 174.813 43.688 174.779 44.364H173.609C173.669 43.3413 173.986 42.557 174.558 42.011C175.13 41.4563 175.866 41.179 176.768 41.179C177.626 41.179 178.306 41.4087 178.809 41.868C179.311 42.3273 179.563 42.9773 179.563 43.818C179.563 44.5113 179.337 45.2177 178.887 45.937C178.445 46.6477 177.886 47.3107 177.21 47.926C176.542 48.5327 175.853 49.0483 175.143 49.473H179.797V50.448H173.492V49.59ZM180.491 42.44V41.335H183.117V50.5H181.869V42.44H180.491Z"
        fill={getPieceTextColor('21', props)}
        onClick={() => props.onPieceClick('21')}
      />
      <defs>
        <filter
          id="filter0_d_741_3561"
          x="83"
          y="7.5"
          width="60"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter1_d_741_3561"
          x="114"
          y="0.5"
          width="62"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter2_d_741_3561"
          x="63"
          y="25.5"
          width="57"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter3_d_741_3561"
          x="46"
          y="53.5"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter4_f_741_3561"
          x="67.7737"
          y="86.2737"
          width="15.4526"
          height="18.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter5_d_741_3561"
          x="29"
          y="76.5"
          width="67"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter6_f_741_3561"
          x="50.7737"
          y="111.274"
          width="17.4526"
          height="20.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter7_d_741_3561"
          x="13"
          y="106.5"
          width="76"
          height="79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter8_f_741_3561"
          x="37.7737"
          y="151.274"
          width="26.4526"
          height="23.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter9_d_741_3561"
          x="-1"
          y="197.5"
          width="75"
          height="73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter10_f_741_3561"
          x="22.7737"
          y="233.274"
          width="22.4526"
          height="29.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter11_d_741_3561"
          x="4"
          y="152.5"
          width="74"
          height="77"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter12_f_741_3561"
          x="29.7737"
          y="193.274"
          width="18.4526"
          height="24.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter13_d_741_3561"
          x="185"
          y="7.5"
          width="60"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter14_d_741_3561"
          x="152"
          y="0.5"
          width="62"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter15_d_741_3561"
          x="208"
          y="25.5"
          width="57"
          height="61"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter16_d_741_3561"
          x="224"
          y="53.5"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter17_f_741_3561"
          x="244.774"
          y="86.2737"
          width="15.4526"
          height="18.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter18_d_741_3561"
          x="232"
          y="76.5"
          width="67"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter19_f_741_3561"
          x="259.774"
          y="111.274"
          width="17.4526"
          height="20.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter20_d_741_3561"
          x="239"
          y="106.5"
          width="76"
          height="79"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter21_f_741_3561"
          x="263.774"
          y="151.274"
          width="26.4526"
          height="23.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter22_d_741_3561"
          x="254"
          y="197.5"
          width="75"
          height="73"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter23_f_741_3561"
          x="282.774"
          y="233.274"
          width="22.4526"
          height="29.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
        <filter
          id="filter24_d_741_3561"
          x="250"
          y="152.5"
          width="74"
          height="77"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-14" />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_741_3561" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_741_3561" result="shape" />
        </filter>
        <filter
          id="filter25_f_741_3561"
          x="279.774"
          y="193.274"
          width="18.4526"
          height="24.4526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.613162" result="effect1_foregroundBlur_741_3561" />
        </filter>
      </defs>
    </svg>
  );
}
